// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1joeG","content":"GlobalSearch_content__NVnNA"};